module.exports = __webpack_public_path__ + "static/media/exclamation.fe796b08.svg";